import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Col, Title } from './styles';
import VisitUs from '../visit-us';
import OpeningTimes from '../opening-times';
import ContactUs from '../contact-us';
import RichText from '../rich-text';

const ShopInfo = ({
  contactNumber,
  contactEmail,
  openingTimes,
  longAddressLine1,
  longAddressLine2,
  longAddressPostcode,
  longAddressTown,
  disabledAccessInformation,
  parkingInformation,
  responseTapClass,
}) => {
  const times = openingTimes ? JSON.parse(openingTimes.internal.content) : null;
  const showVisit =
    times ||
    longAddressLine1 ||
    longAddressLine2 ||
    longAddressPostcode ||
    longAddressTown;

  return (
    <Wrapper>
      {showVisit && (
        <Col>
          <VisitUs
            data={times}
            longAddressLine1={longAddressLine1}
            longAddressLine2={longAddressLine2}
            longAddressPostcode={longAddressPostcode}
            longAddressTown={longAddressTown}
          />
        </Col>
      )}

      {times && (
        <Col>
          <OpeningTimes data={times} />
        </Col>
      )}
      {(contactEmail || contactNumber) && (
        <Col>
          <ContactUs
            email={contactEmail}
            phone={contactNumber}
            responseTapClass={responseTapClass}
          />
        </Col>
      )}
      {disabledAccessInformation && (
        <Col>
          <Title>Accessibility</Title>
          {disabledAccessInformation ? (
            <RichText richText={disabledAccessInformation} />
          ) : null}
          {parkingInformation ? (
            <RichText richText={parkingInformation} />
          ) : null}
        </Col>
      )}
    </Wrapper>
  );
};

ShopInfo.propTypes = {
  longAddressLine1: PropTypes.string,
  longAddressLine2: PropTypes.string,
  longAddressPostcode: PropTypes.string,
  longAddressTown: PropTypes.string,
  contactNumber: PropTypes.string,
  contactEmail: PropTypes.string,
  openingTimes: PropTypes.object,
  disabledAccessInformation: PropTypes.object,
  parkingInformation: PropTypes.object,
  responseTapClass: PropTypes.string,
};

export default ShopInfo;
